import React from 'react';
import { Icon } from '@express-labs/raven-ui';
import PropTypes from 'prop-types';

function MyAccountIcon(props) {
  const { className, ...restOfProps } = props;
  return (
    <button type="button" className={className} {...restOfProps} aria-label="my account">
      <Icon icon="account" />
    </button>
  );
}

MyAccountIcon.meta = {
  VERSION: '1.0.0',
};

MyAccountIcon.propTypes = {
  className: PropTypes.string,
};

MyAccountIcon.defaultProps = {
  className: null,
};

export default MyAccountIcon;
